module.exports = "<el-container>\n  <el-main>\n    <router-view></router-view>\n  </el-main>\n</el-container>"